
import React from 'react';
import { motion } from 'framer-motion';
import LuxuryButton from "@/components/ui/luxury-button";
import { Link } from "react-router-dom";

const PartnerHero = () => {
  return (
    <section className="relative min-h-screen flex items-center bg-gradient-to-br from-juv-deep-chestnut via-juv-terracotta to-juv-rose-clay overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 bg-black/20" />
      
      <div className="apple-container relative z-10">
        <div className="max-w-5xl mx-auto text-center">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
          >
            <h1 className="apple-headline text-white mb-8 font-serif">
              Your Dental Office,<br />
              <span className="font-semibold">Reimagined.</span>
            </h1>
            
            <p className="apple-subheadline text-white/90 mb-12 max-w-4xl mx-auto">
              Unlock a new revenue stream by offering high-margin aesthetic treatments—all without hiring new staff, buying lasers, or changing your brand.
            </p>
            
            <LuxuryButton 
              asChild
              size="lg" 
              variant="primary"
              glowEffect
              className="px-12 py-6 text-xl rounded-full font-medium shadow-2xl apple-hover-scale bg-white text-juv-deep-chestnut hover:bg-white/95"
            >
              <Link to="#qualify">
                See If Your Office Qualifies
              </Link>
            </LuxuryButton>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default PartnerHero;
